export const fblthpTotallyLostArtCrop =
	"https://cards.scryfall.io/art_crop/front/0/5/05f0b6ce-eb70-4f42-9360-c7d09f48a5c5.jpg?1562300269";
